export const getCurrentUser = state => state.CurrentUser;
export const getCurrentUserId = state => getCurrentUser(state).user_id;
export const isLoggedIn = state => getCurrentUser(state).loggedIn;
export const getBlockList = state => state.CurrentUser.blockList;
export const getTOSAccepted = state => state.CurrentUser.tnc_accepted;
